export default __webpack_public_path__ + "static/media/patient-diagnoses.4c6de394.less";